<template>
  <v-list>
    <v-list-item
      v-for="language in languages"
      :key="language.locale"
      :to="{ name: $route.name, params: { lang: language.locale } }"
    >
      <v-list-item-title>{{ language.name }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import languages from '@/languages'

export default {
  name: 'LanguageSelector',
  data: function () {
    return {
      languages
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
